<template>
  <div>
    <v-card class="mb-2 light-green lighten-4">
      <v-card-text>
        <div class="d-flex">
          <div style="width: 238px;">
            <div class="d-flex">
              <div>{{ toLocaleDateString(ss.ServiceDate) }}</div>
              <v-spacer />
              <div>{{ ss.StatusDescription }}</div>
            </div>
            <div class="d-flex">
              <div>{{ ss.ServiceType }}</div>
              <v-spacer />
              <div>{{ ss.AssignedTo }}</div>
              <v-spacer />
              <div>Stop {{ ss.StopNumber }}</div>
            </div>
          </div>
          <v-spacer />
          <div>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="editScheduledServiceClick"
                  ><v-icon :color="feature.services.color">
                    {{ feature.services.icon }}
                  </v-icon>
                </v-btn>
              </template>
              <span>Edit Service</span>
            </v-tooltip>
          </div>
        </div>
        <div class="d-flex">
          <div v-if="ss.FrequencyDescription">
            {{ ss.FrequencyDescription }}
          </div>
          <div v-if="ss.RouteCode">Route {{ ss.RouteCode }}</div>
          <v-spacer />
          <div v-if="ss.SeasonDescription">{{ ss.SeasonDescription }}</div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { feature } from '@/use/Constants'
import { toLocaleDateString } from '@/use/DateFormatter'
export default {
  name: 'ServiceSummaryCard',
  props: {
    ss: {
      type: Object,
      required: true
    }
  },
  setup(props, context) {
    const editScheduledServiceClick = () => {
      context.emit('editScheduledService', props.ss.ScheduledServiceId)
    }

    return { feature, editScheduledServiceClick, toLocaleDateString }
  }
}
</script>

<style lang="scss" scoped></style>
